import { combineReducers } from "redux";
import userReducers from "./user";
import applicationReducer from "./application";
import reportReducer from "./report";
const rootReducer = combineReducers({
  user: userReducers,
  app: applicationReducer,
  report: reportReducer
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
